
export const checkTokenValidity = () => {
    try {
        const storedUser = localStorage.getItem('user');
        const storedAccessToken = storedUser ? JSON.parse(storedUser).accessToken : '';
        return storedAccessToken.length > 0
    } catch (error) {
      console.error('Error decoding JWT token:', error);
    }
  };